import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const artigoRoutes: RouteRecordRaw[] = [
    {
        path: "/artigo",
        name: "artigo",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_ARTIGO},
        component: () => import("@/modules/artigo/pages/PageArtigo.vue")
    },
    {
        path: "/artigo/classificacao",
        name: "artigo-classificacao",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_CLASSIFICACAO_ARTIGO},
        component: () => import("@/modules/artigo/pages/PageClassificacaoArtigo.vue")
    },
    {
        path: "/artigo/estoque",
        name: "artigo-estoque",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_GESTAO_ESTOQUE},
        component: () => import("@/modules/artigo/pages/PageGestaoEstoque.vue")
    },
];
